import {
  DetailPanel,
  DetailPanelGrid,
  type DetailPanelGridProps,
  type DetailPanelProps,
} from '@/components/shared';

export type ProjectDetailPanelGridProps = DetailPanelGridProps;
export type ProjectDetailPanelProps = DetailPanelProps;

export const ProjectDetailPanelGrid = DetailPanelGrid;
export const ProjectDetailPanel = DetailPanel;
